/* eslint-disable camelcase */
import { connect } from 'react-redux';
import * as actions from './TopNavActions';
import TopNavView from './TopNavView';
import {
  showDashboard,
  showClientsList,
  homeIsSearchClients,
  showAddClient,
  whiteLabelDashboardLogoCssStyleSelector,
  showFinancialPlanningSelector,
  selectCanSendFeedback,
} from '../../AdviserArea/AdviserAreaSelector';
import { currentRouteSelector } from '../../CommonComponents/Router/Selector';

const mapStateToProps = (state, { client, showAdminAreaLink, absolute_logo_url }) => {
  const subdivision = state.TopNav;

  return {
    absolute_logo_url,
    is_initialized: subdivision ? subdivision.is_initialized : false,
    unread_count: subdivision ? subdivision.unread_count : 0,
    notifications: subdivision ? subdivision.notifications : [],
    settings_on: subdivision ? subdivision.settings_on : true,
    notifications_on: subdivision ? subdivision.notifications_on : true,
    showAdminAreaLink,
    client,
    showDashboard: showDashboard(state),
    showClientsList: showClientsList(state),
    homeIsSearchClients: homeIsSearchClients(state),
    showAddClient: showAddClient(state),
    route: currentRouteSelector(state),
    whiteLabelDashboardLogoCssStyle: whiteLabelDashboardLogoCssStyleSelector(state),
    showFinancialPlanning: showFinancialPlanningSelector(state),
    canSendFeedback: selectCanSendFeedback(state),
  };
};

const mapDispatchToProps = dispatch => ({
  fetch_data() {
    dispatch(actions.fetch_data());
  },
  set_timer(timer) {
    dispatch(actions.set_timer(timer));
  },
  clear_timer() {
    clearInterval(ADV.store.getState().TopNav.notification_timer);
    dispatch(actions.clear_timer());
  },
  mark_all_read() {
    dispatch(actions.mark_all_read());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNavView);
